module.exports = __webpack_public_path__ + "static/media/trashIcon.37571220.svg";